export default __webpack_public_path__ + "static/media/none-editor.26c1e812.svg";